"use client";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { useState } from "react";

const ReactQueryProvider = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 0, // Data is always considered stale (refetch on mount)
            cacheTime: 1000 * 60 * 60 * 24, // Cache for 24 hours (until hard refresh)
            refetchOnMount: true, // Refetch in background when component mounts
            refetchOnWindowFocus: false, // Don't refetch when window regains focus
            refetchOnReconnect: true, // Refetch when internet reconnects
            retry: 1, // Retry failed requests once
            retryDelay: 1000, // Wait 1 second before retry
          },
          mutations: {
            retry: 1, // Retry failed mutations once
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};

export default ReactQueryProvider;
